export function parseBpayDetailsResponse(data) {
  const maskedMobileNumber = data?.masked_mobile;

  if (!maskedMobileNumber) {
    return null;
  }

  const verifyOtpAction = data?.actions?.find(
    ({ name }) => name === "verify-otp",
  );

  if (!verifyOtpAction) {
    return null;
  }

  const resendOtpAction = data?.actions?.find(
    ({ name }) => name === "resend-otp",
  );

  if (!resendOtpAction) {
    return null;
  }

  return {
    maskedMobileNumber,
    verifyOtpAction,
    resendOtpAction,
  };
}
